import Category from "./category";

const Diffcount = {
  Category,
};

export default Diffcount;
